import {FormTextInput, FormTextInputProps} from "../../components-shared/forms/form-text-input/form-text-input-view"
import React, {ChangeEvent, FormEvent, useState} from "react"
import {createEmptyLoginFormViewModel, LoginFormViewModel, LoginFormViewModelTextInputFields, validateLoginFormViewModel} from "./login-form-viewmodel"
import {FormSubmitButton, SubmitState} from "../../components-shared/forms/form-submit-button/form-submit-button"
import {allValid} from "../../util/validation/validation-result"
import {WithVerticalSpacing} from "../../components-shared/spacing/with-vertical-spacing"
import {Message} from "../../components-shared/message/message"

interface LoginFormProps {
  onSubmit: (loginForm: LoginFormViewModel) => void
  error?: string
}

type VisibleValidationResults = {
  [K in LoginFormViewModelTextInputFields]: boolean
}

const InitiallyVisibleValidationResult: VisibleValidationResults = {
  email: false,
  password: false
}

const AllValidationResultVisible: VisibleValidationResults = {
  email: true,
  password: true
}

export const LoginForm: React.FC<LoginFormProps> = ({onSubmit, error}) => {
  const [submitState, setSubmitState] = useState(SubmitState.Initial)
  const [viewModel, setViewModel] = useState<LoginFormViewModel>(() => createEmptyLoginFormViewModel())
  const validationResults = validateLoginFormViewModel(viewModel)
  const [visibleValidationResult, setVisibleValidationResults] = useState<VisibleValidationResults>(InitiallyVisibleValidationResult)
  const [internalValidationResults, setInternalValidationResults] = useState(validationResults)

  const handleChange = (field: LoginFormViewModelTextInputFields) => (e: ChangeEvent<HTMLInputElement>) => {
    setSubmitState(SubmitState.Initial)
    setViewModel({...viewModel, [field]: e.target.value})
  }

  const handleBlur = (field: LoginFormViewModelTextInputFields) => () => {
    setVisibleValidationResults({...visibleValidationResult, [field]: true})
    setInternalValidationResults({...internalValidationResults, [field]: validationResults[field]})
  }

  const handleSubmitForm = async (e: FormEvent) => {
    e.preventDefault()
    setVisibleValidationResults(AllValidationResultVisible)
    setInternalValidationResults(validationResults)
    const allFieldsValid = allValid(validationResults)

    if (allFieldsValid) onSubmit(viewModel)
  }

  const textInputProps = (name: LoginFormViewModelTextInputFields): Pick<FormTextInputProps, "value" | "validationResult" | "showValidity" | "onChange" | "onBlur"> => ({
    value: viewModel[name],
    validationResult: internalValidationResults[name],
    showValidity: visibleValidationResult[name],
    onChange: handleChange(name),
    onBlur: handleBlur(name)
  })

  return <form onSubmit={handleSubmitForm}>
    <WithVerticalSpacing>
      {error && <Message type="error">{error}</Message>}
      <FormTextInput label="Emailadres" {...textInputProps("email")}/>
      <FormTextInput {...textInputProps("password")} label="Wachtwoord" type="password"/>
      <FormSubmitButton submitState={submitState} contents="Inloggen" submittingContents="Bezig met inloggen" submittedContents="Ingelogd" />
    </WithVerticalSpacing>
  </form>
}